<div *ngIf="isLoading">Loading ExpenditureCategory List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="expenditureCategory" [(ngModel)]="model.expenditureCategory" [required]="required">
  <option *ngFor="let singleExpenditureCategory of expenditureCategories" [ngValue]="singleExpenditureCategory">{{ singleExpenditureCategory.name }}</option>
</select>
